import Vue from 'vue'
import Vuex from 'vuex'
import * as firebase from 'firebase'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    listes: [],
    user: null,
    loading: false,
    error: null
  },
  mutations: {
    supprListe(state, payload) {
      const index = state.listes.map(function(item) {
        return item.id
      }).indexOf(payload);
      state.listes.splice(index, 1);
    },
    setListes (state, payload) {
      state.listes = payload
    },
    ajListe(state, payload) {
      state.listes.push(payload);
    },
    supprItem(state, payload) {
      const index = state.listes.map(function(item) {
        return item.id
      }).indexOf(payload.idListe);
      const indexObj = state.listes[index].items.map(function(item) {
        return item.id
      }).indexOf(payload.index);
      state.listes[index].items.splice(indexObj, 1);
    },
    ajItem(state, payload) {
      const rang = state.listes.map(function(item) {
        return item.id
      }).indexOf(payload.idListe);
      if(!state.listes[rang].items) {
        state.listes[rang].items = [];
      }
      const objet = {
        id: payload.id,
        item: payload.nom,
      }
      state.listes[rang].items.push(objet);
    },
    setUser (state, payload) {
      state.user = payload
    },
    setLoading (state, payload) {
      state.loading = payload
    },
    setError (state, payload) {
      state.error = payload
    },
    clearError (state) {
      state.error = null
    },
    clearUser (state) {
      state.user = null
    }
  },
  actions: {
    supprListe({commit}, payload) {
      commit('setLoading', true)
      firebase.database().ref('listes').child(payload).remove()
        .then(() => {
          commit('setLoading', false)
          commit('supprListe', payload)
        })
        .catch((error) => {
          commit('setLoading', false)
          console.log(error)
        })
    },
    loadListes ({commit}) {
      commit('setLoading', true)
      firebase.database().ref('listes').once('value')
        .then((data) => {
          const listes = []
          const obj = data.val()
          for (let cle in obj) {
            const array = []
            const objit = obj[cle].items
            console.log(objit)
            for (let it in objit) {
              console.log(it)
              array.push({id: it, item: objit[it]})
            }
            listes.push({
              id: cle,
              user: obj[cle].user,
              nom: obj[cle].nom,
              type: obj[cle].type,
              items: array
            })
          }
          commit('setLoading', false)
          commit('setListes', listes)
        })
        .catch(
          (error) => {
            console.log(error)
            commit('setLoading', false)
          }
        )
    },
    ajListe({commit}, payload) {
      commit('setLoading', true)
      const objet = {
        nom: payload.nom,
        type: payload.typeL,
        user: payload.user,
        items: []
      }
      firebase.database().ref('listes').push(objet)
        .then((data) => {
          commit('setLoading', false)
          const key = data.key
          commit('ajListe', {
            ...objet,
            id: key
          })
        })
        .catch((error) => {
          commit('setLoading', false)
          console.log(error)
        })
    },
    supprItem({commit}, payload) {
      commit('setLoading', true)
      firebase.database().ref('listes').child(payload.idListe).child('items').child(payload.index).remove()
        .then(() => {
          commit('setLoading', false)
          commit('supprItem', payload)
        })
        .catch((error) => {
          commit('setLoading', false)
          console.log(error)
        })
    },
    ajItem({commit}, payload) {
      commit('setLoading', true)
      const objet = {
        nom: payload.nom,
        idListe: payload.idListe
      }
      firebase.database().ref('listes').child(payload.idListe).child('items').push(payload.nom)
        .then((data) => {
          commit('setLoading', false)
          const key = data.key
          commit('ajItem', {
            ...objet,
            id: key
          })
        })
        .catch((error) => {
          commit('setLoading', false)
          console.log(error)
        })
    },
    signUserUp ({commit}, payload) {
      commit('setLoading', true)
      commit('clearError')
      firebase.auth().createUserWithEmailAndPassword(payload.email, payload.password)
        .then(
          response => {
            commit('setLoading', false)
            const newUser = {
              id: response.user.uid
            }
            commit('setUser', newUser)
          }
        )
        .catch(
          error => {
            commit('setLoading', false)
            commit('setError', error)
          }
        )
    },
    signUserIn ({commit}, payload) {
      commit('setLoading', true)
      commit('clearError')
      firebase.auth().signInWithEmailAndPassword(payload.email, payload.password)
        .then(
          response => {
            commit('setLoading', false)
            const newUser = {
              id: response.user.uid
            }
            commit('setUser', newUser)
          }
        )
        .catch(
          error => {
            commit('setLoading', false)
            commit('setError', error)
          }
        )
    },
    autoSignIn ({commit}, payload) {
      commit('setUser', {id: payload.uid})
    },
    clearError ({commit}) {
      commit('clearError')
    },
    clearUser ({commit}) {
      firebase.auth().signOut()
      commit('clearUser')
    }
  },
  getters: {
    user(state) {
      return state.user;
    },
    loading (state) {
      return state.loading;
    },
    error (state) {
      return state.error;
    },
  }
})
